import { AccountBoxOutlined } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

export const ImagePlaceHolder = styled(AccountBoxOutlined)`
  width: 200px;
  height: 200px;
`;